import Button from '@doordash/component-button'
import { Stack, StackChildren, Text } from '@doordash/design-language'
import { noop } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as events from '../../../events'

import t from './strings'

type SignW9Props = {
  uniqueLink: string
  isSubmitting?: boolean
  goToW9Signing?: (uniqueLink: string) => Promise<any>
  trackDropshippingEvent?: (string) => Promise<any>
}

export class SignW9 extends React.Component<SignW9Props> {
  public static defaultProps = {
    isSubmitting: false,
    goToW9Signing: noop,
    trackDropshippingEvent: noop,
  }

  public componentDidMount() {
    this.props.trackDropshippingEvent('DA_dxds_w9_page')
  }

  public submitHandler = async () => {
    const { goToW9Signing, uniqueLink } = this.props
    await goToW9Signing(uniqueLink)
  }

  public render() {
    return (
      <StackChildren>
        <Stack>
          <Stack>
            <Text styles={Text.Styles.Bold24}>{t.title()}</Text>
          </Stack>
          <Text>{t.text()}</Text>
          <Button
            accessibilityDescribedBy={'signw9'}
            onClick={this.submitHandler}
            state={
              this.props.isSubmitting
                ? Button.States.Loading
                : Button.States.Default
            }
          >
            {t.button()}
          </Button>
        </Stack>
        <Text
          size={Text.Sizes.S14}
          lineHeight={Text.LineHeights.S18}
          color={Text.Colors.TextTertiary}
        >
          {t.terms()}
        </Text>
      </StackChildren>
    )
  }
}

const mapStateToProps = state => ({
  isSubmitting: state.w9Link.isSubmitting,
})

const mapDispatchToProps = {
  goToW9Signing: actions.goToW9Signing,
  trackDropshippingEvent: events.trackDropshippingEvent,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignW9)
